import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.js';

import { IApplyFiltersProps, IApplyFiltersState } from './models/index.js';
import Button from './styledComponents/Button.js';
import Label from './styledComponents/Label.js';
import Wrapper from './styledComponents/Wrapper.js';
import { applyFiltersStyle } from './styles/ApplyFilters.styles.js';

export class RawApplyFilters extends Component<IApplyFiltersProps, IApplyFiltersState> {
	static configurationKey = 'applyFilters' as const;
	static styleKey = 'applyFilters' as const;
	constructor(props: IApplyFiltersProps) {
		super(props);
	}

	render() {
		const { className, applyFiltersStore } = this.props;

		if (!applyFiltersStore) {
			return null;
		}
		const { buttonId, buttonProps, labelProps } = applyFiltersStore;
		const ariaLabel = buttonProps.text || buttonProps.iconProps?.accessibilityText || 'Apply Filters';

		return (
			<Wrapper className={className}>
				{
					labelProps && <Label {...labelProps}/>
				}
				<Button
					key={'button'}
					{...buttonProps}
					id={buttonId}
					aria-label={ariaLabel}
				/>
			</Wrapper>
		);
	}
}

export const ApplyFilters = inject('appStore')(observer(RawApplyFilters));
export default InjectedStyledComponent(
	ApplyFilters,
	'applyFilters',
	undefined,
	undefined,
	undefined,
	undefined,
	applyFiltersStyle,
);
